<template>
    <div class="w-full">
        <div
            class="self-stretch h-7 flex-col justify-start items-start gap-4 flex"
        >
            <div class="flex-col justify-start items-start gap-2 flex">
                <div class="text-slate-800 text-lg font-medium leading-7">
                    {{ $filters.formatThousand(totalPointsCost) }}
                </div>
            </div>
        </div>
        <div
            class="self-stretch h-12 pt-6 flex-col justify-start items-start gap-2.5 flex"
        >
            <div class="w-[76.80px] h-6 relative">
                <img
                    class="w-auto h-full left-0 top-0 absolute"
                    :src="propertyProgram.image"
                />
            </div>
        </div>
        <div
            class="w-full pt-8 flex-row lg:flex-col justify-start items-start gap-4 flex"
            v-if="pointsByUser.length > 0"
        >
            <div
                class="flex-col justify-start items-start gap-2 flex w-1/2 lg:w-auto"
                v-for="user in pointsByUser"
                :key="user"
            >
                <UsernameIcon :user="user" />
                <!-- start enough points pill -->
                <div
                    class="px-2 py-0.5 rounded-full justify-start items-center gap-2 flex"
                    :class="{
                        'text-orange-600 bg-orange-50':
                            user.canAffordMessage != 'Not enough',
                        'bg-slate-100 text-slate-500':
                            user.canAffordMessage == 'Not enough',
                    }"
                >
                    <i
                        class="fa-solid"
                        :class="{
                            'fa-check-double':
                                user.canAffordMessage == 'Enough',
                            'fa-check':
                                user.canAffordMessage ==
                                'Enough with transferring',
                            'fa-circle-x':
                                user.canAffordMessage == 'Not enough',
                        }"
                    ></i>
                    <div class="text-xs font-medium leading-none">
                        {{ user.canAffordMessage }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import UsernameIcon from '@/components/ui/username-icon/username-icon.vue';
export default {
    components: { UsernameIcon },
    props: {
        totalPointsCost: Number,
        programPoints: Array,
        propertyProgram: Object,
        sourceProgramUserPoints: Array,
    },
    emits: ['pointsCalculated'],
    setup(props, { emit }) {
        const pointsByUser = computed(() => {
            return props.sourceProgramUserPoints.reduce(
                (result, currProgram) => {
                    currProgram.points.forEach((user) => {
                        if (!result[user.userName]) {
                            result[user.userName] = {
                                userName: user.userName,
                                userId: user.userId,
                                hasEnoughProgramPoints: false,
                                hasEnoughTransferPoints: false,
                                hasEnoughCombinedPoints: false,
                                canAffordMessage: 'Not enough',
                            };
                        }

                        if (user.hasEnoughProgramPoints) {
                            result[user.userName].hasEnoughProgramPoints = true;
                        }
                        if (user.hasEnoughTransferPoints) {
                            result[user.userName].hasEnoughTransferPoints =
                                true;
                        }
                        if (user.hasEnoughCombinedPoints) {
                            result[user.userName].hasEnoughCombinedPoints =
                                true;
                        }

                        if (user.hasEnoughProgramPoints) {
                            result[user.userName].canAffordMessage = 'Enough';
                        } else if (
                            user.hasEnoughCombinedPoints ||
                            user.hasEnoughTransferPoints
                        ) {
                            result[user.userName].canAffordMessage =
                                'Enough with transferring';
                        }
                    });
                    return result;
                },
                {}
            );
        });

        const recommendCards = () => {
            let usersWithoutEnoughPoints;
            //** pointsByUser array will only have values if there are Transfer Partners for the program. If not it'll be empty (else condition below). **

            if (Object.keys(pointsByUser.value).length) {
                usersWithoutEnoughPoints = Object.keys(
                    pointsByUser.value
                ).reduce((arr, currUser) => {
                    if (
                        !pointsByUser.value[currUser].hasEnoughTransferPoints &&
                        !pointsByUser.value[currUser].hasEnoughProgramPoints &&
                        !pointsByUser.value[currUser].hasEnoughCombinedPoints
                    ) {
                        arr.push(pointsByUser.value[currUser]);
                    }
                    return arr;
                }, []);
            } else {
                usersWithoutEnoughPoints = props.programPoints.filter(
                    (user) => {
                        const hasEnoughProgramPoints =
                            user.points >= props.totalPointsCost;
                        if (!hasEnoughProgramPoints)
                            return { ...user, hasEnoughProgramPoints };
                    }
                );
            }
            emit('pointsCalculated', usersWithoutEnoughPoints);
        };

        recommendCards();

        return { pointsByUser };
    },
};
</script>
